export default __webpack_public_path__ + "static/media/Header-Logo-Banner.bfddbd4f.png";